<template>
  <b-container fluid>
    <b-row>
      <b-col md="12">
        <div class="iq-card p-3 row">
          <div class="col-12 col-sm-6 col-md-8 col-lg-6">
            <h4>
              <i class="fa fa-headset" aria-hidden="true" style="font-size: 21px; margin-right: 10px; color: var(--iq-primary);"></i>
              {{ cvCardTitle }}
            </h4>
          </div>
          <div class="col-12 col-sm-6 col-md-6 col-lg-6">
            <router-link v-if="userData.user_role=='USERROLE11111' || userData.user_role=='USERROLE11118'" to="/email_template_list" target="_blank">
              <b-button class="right-align-sm mt-2 mb-1 mt-sm-0 ml-2" variant="primary">Email Templates</b-button>
            </router-link>
          </div>
        </div>
        <div class="iq-card row p-3">
          <b-col lg="8">
            <b-row>
              <!-- Backend Search -->
               <b-col class="col-12 mb-3">
                <b-form-input class="form-control"
                  @input="searchChatMessageWithParams"
                  v-model="search_param"
                  type="search"
                  :placeholder="cvSearchText"></b-form-input>
              </b-col><!-- Backend Search -->

              <b-col class="mb-2 col-12 col-sm-4">
                <select v-model="whereFilter.group_id" class="form-control mb-2" @change="setFilters" title="Choose group id">
                  <option :value="null" disabled>Choose group</option>
                  <option :value="null">All</option>
                  <option v-for="(item, index) in groupFiltersList" :key="index" :value="item.group_id">
                    {{ item.group_name }}
                  </option>
                </select>
              </b-col>
              <b-col class="mb-2 col-12 col-sm-4">
                <select v-model="whereFilter.message_channel" class="form-control mb-2" @change="setFilters" title="Choose group id">
                  <option v-for="(item, index) in messageChannelList" :key="index" :value="item.message_channel">
                    {{ item.message_channel }}
                  </option>
                </select>
              </b-col>
              <!-- Replies only/All filter -->
              <b-col class="mb-2 col-12 col-sm-4">
                <select v-model="whereFilter.is_reply" class="form-control mb-2" @change="setFilters" title="Message Category">
                  <option :value="1">
                    Replies only
                  </option>
                  <option :value="0">
                    All messages
                  </option>
                </select>
              </b-col><!-- Replies only/All filter -->

              <b-col class="mb-2 col-12 col-sm-4">
                <select v-model="domain_filter" class="form-control" @change="setFilters('domain')" title="Domain Filter">
                  <option :value="null" disabled>Choose Domain</option>
                  <option :value="null">All</option>
                  <option v-for="(domain, index) of appDomain" :key="index+1" :value="domain">
                    {{domain}}
                  </option>
                </select>
              </b-col>
            </b-row>
          </b-col>
          <b-col class="mb-2 col-12 col-lg-4 date_csv">
            <div class="dateRange">
              <i class="fa-solid fa-filter-circle-xmark Download_button" title="Remove all filter" @click="removeAllFilter"></i>
              <i v-if="chtmsgObjList && chtmsgObjList.length > 0" :csv-title="csvTitle" class="fa-solid fa-file-csv Download_button" title="Download CSV" @click="backendCsvDownload"></i>
            </div>
          </b-col>
        </div>
        <div class="iq-card row p-3">
          <b-col class="container_minheight" md="12" v-if="chtmsgObjList && chtmsgObjList.length > 0" :key="currentBatchNo">
            <b-table
              hover
              responsive
              :items="chtmsgObjList"
              :fields="columns"
              :no-border-collapse="true"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :filter="filter"
              :filter-included-fields="filterOn"
              :current-page="currentBatchNo"
              :per-page="dataPerPage"
            >
              <template v-slot:cell(user_id)="data">
                <span><b>{{data.item.user_name}}</b></span><br>
                <span v-if="data.item.participants" class="primary-color"><small>ReplyTo:&nbsp;{{getParticipants(data.item.participants)}}</small></span><br>
                <small>User / Sender ID:&nbsp;{{data.item.user_id}}</small>&nbsp;&nbsp;<i class="fa-solid fa-copy pointer" title="Copy User / Sender ID" @click="doCopy(data.item.user_id)"></i><br>
                <!-- <small>Group Name:&nbsp;{{data.item.group_name}}</small><br> -->
                <small>Group ID:&nbsp;{{data.item.group_id}}</small>&nbsp;&nbsp;<i class="fa-solid fa-copy pointer" title="Copy Group ID" @click="doCopy(data.item.group_id)"></i><br>
                <small>MsgID:&nbsp;{{data.item.this_message_id }}</small>&nbsp;&nbsp;<i class="fa-solid fa-copy pointer" title="Copy This Message ID" @click="doCopy(data.item.this_message_id)"></i><br>
                <small>Request MsgID:&nbsp;&nbsp;{{ data.item.message_id }}</small>&nbsp;&nbsp;<i class="fa-solid fa-copy pointer" title="Copy This Message ID" @click="doCopy(data.item.message_id)"></i><br>
                <b-button v-if="!data.item.editable" class="actionIcon font-size-20" @click="chatMessageEdit(data.item)" title="Edit Message"><i class="ri-ball-pen-fill m-0"></i></b-button>
                <b-button v-if="data.item.is_reply" class="actionIcon font-size-20" @click="ChatMessageView(data.item)" title="Send Response"><i class="fa fa-envelope-o"></i></b-button>
                <br>
                <b-badge v-if="data.item.app_domain" style="vertical-align: middle; color: #FFF; background: #e5252c !important;" class="mt-2 mr-2">
                  {{data.item.app_domain}}
                </b-badge>
                <b-badge v-if="data.item.is_reply_delivered == 1" style="vertical-align: middle; color: #FFF; background: green !important;" class="mt-2">
                  Agent Reply Sent
                </b-badge>
              </template>
              <template v-slot:cell(message_subject)="data">
                <span class="pointer" @click="ChatMessageView(data.item)">{{ data.item.message_subject }}</span>
              </template>
              <template v-slot:cell(text_msg)="data">
                <span class="pointer" v-html="data.item.text_msg.substring(0, 200) +  ' ......'" @click="ChatMessageView(data.item)"></span>
              </template>
              <template v-slot:cell(created_on)="data">
                {{data.item.created_on | dateFormat}}
              </template>
            </b-table>
          </b-col>
          <b-col class="container_minheight" md="12" v-else>
            No data found
          </b-col>
          <b-col sm="12" md="7">
            <b-btn variant="primary" @click="loadMoreData" v-if="showLoadMoreBtn">Load More</b-btn>
          </b-col>
         </div>
      </b-col>
    </b-row>

    <b-modal v-model="showModelChatMessageEdit" scrollable :title="cvEditModalHeader" size="xxl">
      <chatMessageEdit :propOpenedInModal="true" :propChatMessageObj="chtmsgEditObj" @emitCloseChatMessageEditModal="closeChatMessageEditModal" />
      <template #modal-footer="">
        <b-button size="sm" @click="closeChatMessageEditModal()">
          {{cvbtnModalCancel}}
        </b-button>
      </template>
    </b-modal>

    <!-- SendMail -->
    <b-modal
      v-model="showModelReplyMail"
      scrollable
      :title="cvSendMailModalHeader"
      size="xxl"
    >
      <SendMailReply :propOpenedInModal="true" :propreplyMailObj="replyMailObj" propModuleName="chat_message_list" @emitCloseSendMailModal="emitCloseSendMailModal" />
      <template #modal-footer="">
        <b-button size="sm" @click="emitCloseSendMailModal()">
          {{cvbtnModalCancel}}
        </b-button>
      </template>
    </b-modal><!-- SendMail -->

    <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">
      <div v-html="toastMsg"></div>
    </b-toast>
  </b-container>
</template>
<script>
import { ChatMessages } from "../../../FackApi/api/ChatMessage.js"
import chatMessageEdit from "./ChatMessageEdit.vue"
import SendMailReply from "../../../components/SendMailReply.vue"
import { socialvue } from "../../../config/pluginInit.js"
import userPermission from "../../../Utils/user_permission.js"
import Utility from "../../../Utils/utility.js"
import appDomain from "../../../FackApi/json/Domain.json"

export default {
  name: "chatMessageList",
  components: {
    chatMessageEdit,
    SendMailReply
  },
  data () {
    return {
      supportAgntUserIds: process.env.VUE_APP_SUPPORT_AGNT_USER_ID,
      cvCardTitle: "Support Messages",
      cvSearchText: "Type to Search",
      cvDelMessage: "Are you sure?",
      cvEditModalHeader: "Edit Support Message",
      cvbtnModalCancel: "Cancel",
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      toastTitle: "Support Message",
      showModelChatMessageEdit: false,
      sortBy: "name",
      sortDesc: false,
      columns: [
        { label: "#", key: "id", class: "text-left align-text-top", sortable: true },
        { label: "User", key: "user_id", class: "text-left align-text-top w-350px", sortable: true },
        // { label: "Request Message Id", key: "message_id", class: "text-left align-text-top w-300px", sortable: true },
        // { label: "App Domain", key: "app_domain", class: "text-left align-text-top w-300px", sortable: true },
        { label: "Subject", key: "message_subject", class: "text-left align-text-top w-260px", sortable: true },
        { label: "Message", key: "text_msg", class: "text-left align-text-top w-350px", sortable: true },
        // { label: "Message Content Type", key: "message_content_type", class: "text-left align-text-top", sortable: true },
        // { label: "Content Message Data", key: "content_message_data", class: "text-left align-text-top", sortable: true },
        // { label: "Message Type", key: "message_type", class: "text-left align-text-top", sortable: true },
        // { label: "Message Time", key: "message_time", class: "text-left align-text-top", sortable: true },
        // { label: "Is Reply", key: "is_reply", class: "text-left align-text-top", sortable: true },
        { label: "LLM Response Payload", key: "response_payload", class: "text-left align-text-top w-260px", sortable: true },
        { label: "Created On", key: "created_on", class: "text-left align-text-top w-150px", sortable: true },
        { label: "Modified On", key: "modified_on", class: "text-left align-text-top w-150px", sortable: true }
      ],
      chtmsgObjList: [],
      chtmsgEditObj: null,
      filter: null,
      csvTitle: "ChatMessage",
      filterOn: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      delObj: null,
      whereFilter: {
        message_channel: "EMAIL",
        senderId: "",
        groupId: "",
        messageType: "",
        messageTime: "",
        is_reply: 1
      },
      domain_filter: "",
      search_param: "",
      currentBatchNo: 1,
      dataPerPage: 25,
      showLoadMoreBtn: true,
      doCopy: Utility.doCopy,
      groupFiltersList: [],
      messageChannelList: [],
      cvSendMailModalHeader: "Send Reply Mail",
      showModelReplyMail: false,
      replyMailObj: {},
      appDomain: appDomain
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    }
  },
  async beforeMount () {
    // Auth Access for Current User Role
    if (this.userData.user_role == "USERROLE11114") {
      // We will display only the sessions of the user, It is necessary when the user has multiple sessions and he/she wants to view the session
      // DONT CARE CASE
    }
    else if (!userPermission(this, this.userData, this.apiName)) {
      this.$router.back()
    }
  },
  async mounted () {
    socialvue.index()
    await this.groupFilters("group_name , group_id")
    await this.messageChannelFilter("message_channel")
    this.chatMessageList()
  },
  methods: {
    /**
     * set Filters
     */
    async setFilters () {
      this.chatMessageList()
    },
    /**
     * search ChatMessageWithParams
     */
    async searchChatMessageWithParams () {
      if (this.search_param.length <= 3 && this.search_param.length !== 0) {
        return
      }

      this.currentBatchNo = 1
      this.chatMessageList()
    },
    /**
     * load More Data
     */
    async loadMoreData () {
      this.currentBatchNo = this.currentBatchNo + 1
      this.chatMessageList(true)
    },
    /**
     * Calling Function as per whereFilter
     */
    async getChatMessageDateWise () {
      this.chatMessageList()
    },
    /**
     * backend Csv Download
     */
    async backendCsvDownload () {
      this.chatMessageList(false, true)
    },
    /**
     * ChatMessage List
     */
    async chatMessageList (loadViaLoadMore = false, downloadCsv = false) {
      try {
        // setting data for pagination
        this.whereFilter.currentBatchNo = this.currentBatchNo
        this.whereFilter.dataPerPage = this.dataPerPage
        this.whereFilter.search_param = this.search_param
        this.whereFilter.downloadCsv = downloadCsv
        this.whereFilter.domain_name = this.domain_filter
        this.whereFilter.message_channel = this.whereFilter.message_channel ? this.whereFilter.message_channel : "EMAIL"
        this.whereFilter.is_reply = this.whereFilter.is_reply ? this.whereFilter.is_reply : 0

        let ChatMessageListResp = await ChatMessages.ChatMessageList(this, this.whereFilter)
        if (ChatMessageListResp.resp_status) {
          if (downloadCsv) {
            window.open(ChatMessageListResp.resp_csv_file_url)
            return
          }

          if (this.whereFilter.search_param.length >= 0 && !loadViaLoadMore) {
            this.chtmsgObjList = [ ...ChatMessageListResp.resp_data.data ]
          }
          else {
            this.chtmsgObjList = [ ...this.chtmsgObjList, ...ChatMessageListResp.resp_data.data ]
          }
          this.showLoadMoreBtn = true

          // Adding the serial numbers:
          this.chtmsgObjList.forEach((s, index) => { s.id = index + 1 })
          this.totalRows = this.chtmsgObjList.length
        }
        else {
          this.chtmsgObjList = []
          this.currentBatchNo = this.currentBatchNo == 1 ? 1 : (this.currentBatchNo - 1)
          this.showLoadMoreBtn = false
          this.toastMsg = ChatMessageListResp.resp_msg
          this.toastVariant = "danger"
          this.showToast = true
        }
      }
      catch (err) {
        console.error("Exception occurred at chatMessageList() and Exception:", err)
      }
    },
    /**
     * ChatMessage Edit
     */
    chatMessageEdit (item) {
      try {
        this.chtmsgEditObj = item
        this.showModelChatMessageEdit = true
      }
      catch (err) {
        console.error("Exception occurred at chatMessageEdit() and Exception:", err.message)
      }
    },
    /**
     * closeChatMessage EditModal
     */
    closeChatMessageEditModal () {
      this.chatMessageList()
      this.showModelChatMessageEdit = false
    },
    /*
    * groupFilters
    */
    async groupFilters (filterName = null) {
      if (!filterName) {
        return
      }
      try {
        let groupFiltersListResp = await ChatMessages.groupFiltersList(this, filterName)
        if (groupFiltersListResp) {
          this.groupFiltersList = groupFiltersListResp.resp_data
        }
      }
      catch (err) {
        console.error("Exception occurred at univ_filter_list_resp() and Exception:", err.message)
      }
    },
    /*
    * messageChannelFilter
    */
    async messageChannelFilter (filterName = null) {
      if (!filterName) {
        return
      }
      try {
        let messageChannelListResp = await ChatMessages.messageChannelFilterList(this, filterName)
        if (messageChannelListResp) {
          this.messageChannelList = messageChannelListResp.resp_data
        }
      }
      catch (err) {
        console.error("Exception occurred at univ_filter_list_resp() and Exception:", err.message)
      }
    },
    /**
     * emitCloseSendMailModal
     */
    async emitCloseSendMailModal () {
      this.chatMessageList()
      this.showModelReplyMail = false
    },
    /**
     * Chat Message View
     */
    async ChatMessageView (chatData) {
      this.showModelReplyMail = true
      this.replyMailObj = chatData
    },
    /**
     * remove All Filter
     */
    removeAllFilter () {
      this.whereFilter = {
        message_channel: "EMAIL",
        senderId: "",
        groupId: "",
        messageType: "",
        messageTime: "",
        is_reply: 1
      }
      this.chatMessageList(false, false)
    },
    /**
     * Get the participants excluding support agent ids
     */
    getParticipants (participants) {
      participants = participants?.split(",")?.filter(e => !this.supportAgntUserIds?.split(",").includes(e))
      participants = participants && participants[0] ? participants[0].replaceAll(/[\]"]/g, "") : participants
      return participants
    }
  }
}
</script>
